<template>
  <el-timeline-item :timestamp="formatDate(message.CreatedAt)" placement="top">
    <el-card
      class="message-item"
      :body-style="{ padding: '16px' }"
      v-loading="loading"
    >
      <!-- Header - foto y nombre del usario creador -->
      <template #header>
        <div class="flex justify-space-between">
          <div class="message-header flex justify-start align-center">
            <el-avatar
              size="medium"
              class="box"
              :src="create_at_image"
            ></el-avatar>
            <span class="box username strong black-text">
              {{ create_at_name }}
            </span>
          </div>

          <el-dropdown
            trigger="click"
            @command="handleCommand"
            class="box"
            v-if="IsInRoles([roles.SuperUsuario, roles.Message])"
          >
            <span class="el-dropdown-link">
              <i class="mdi mdi-dots-vertical"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit" icon="el-icon-edit"
                >Editar</el-dropdown-item
              >
              <el-dropdown-item command="delete" icon="el-icon-delete"
                >Eiminar</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <!-- Body - Slide de image -->
      <div class="message-body">
        <div class="commentary-message" v-html="message.Content"></div>

        <template v-if="message.Images.length > 0">
          <el-carousel height="400px" :interval="6000">
            <el-carousel-item
              v-for="image in message.Images"
              :key="image.Id"
              class="flex justify-center content-center align-center"
            >
              <el-image :key="image.Src" :src="image.Src"></el-image>
            </el-carousel-item>
          </el-carousel>
        </template>

        <div
          v-show="message.CountLike || message.CountComment > 0"
          class="flex row justify-space-between align-center m-10"
        >
          <div class="box self-start">
            <div class="flex row" v-show="message.CountLike">
              <img
                class="box mr-5"
                height="16"
                src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 16 16'%3e%3cdefs%3e%3clinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3e%3cstop offset='0%25' stop-color='%2318AFFF'/%3e%3cstop offset='100%25' stop-color='%230062DF'/%3e%3c/linearGradient%3e%3cfilter id='c' width='118.8%25' height='118.8%25' x='-9.4%25' y='-9.4%25' filterUnits='objectBoundingBox'%3e%3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='1'/%3e%3cfeOffset dy='-1' in='shadowBlurInner1' result='shadowOffsetInner1'/%3e%3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e%3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0 0 0 0 0 0.299356041 0 0 0 0 0.681187726 0 0 0 0.3495684 0'/%3e%3c/filter%3e%3cpath id='b' d='M8 0a8 8 0 00-8 8 8 8 0 1016 0 8 8 0 00-8-8z'/%3e%3c/defs%3e%3cg fill='none'%3e%3cuse fill='url(%23a)' xlink:href='%23b'/%3e%3cuse fill='black' filter='url(%23c)' xlink:href='%23b'/%3e%3cpath fill='white' d='M12.162 7.338c.176.123.338.245.338.674 0 .43-.229.604-.474.725a.73.73 0 01.089.546c-.077.344-.392.611-.672.69.121.194.159.385.015.62-.185.295-.346.407-1.058.407H7.5c-.988 0-1.5-.546-1.5-1V7.665c0-1.23 1.467-2.275 1.467-3.13L7.361 3.47c-.005-.065.008-.224.058-.27.08-.079.301-.2.635-.2.218 0 .363.041.534.123.581.277.732.978.732 1.542 0 .271-.414 1.083-.47 1.364 0 0 .867-.192 1.879-.199 1.061-.006 1.749.19 1.749.842 0 .261-.219.523-.316.666zM3.6 7h.8a.6.6 0 01.6.6v3.8a.6.6 0 01-.6.6h-.8a.6.6 0 01-.6-.6V7.6a.6.6 0 01.6-.6z'/%3e%3c/g%3e%3c/svg%3e"
                width="16"
              />
              <span class="box comment-message-like-count"
                >{{ message.CountLike }}
              </span>
            </div>
          </div>
          <span
            class="box self-center self-flex-end"
            v-show="message.CountComment > 0"
            dir="auto"
            >{{ message.CountComment }}
            {{
              message.CountComment === 1 ? "comentario" : "comentarios"
            }}</span
          >
        </div>

        <div class="commentary-box">
          <div aria-label="seperator" class="separator-bottom"></div>
          <div class="commentary-tools">
            <span class="commentary-tool">
              <div
                @click="message_like"
                aria-label="Me gusta"
                class="commentary-button w-100"
                role="button"
                tabindex="0"
              >
                <div
                  class="_18vj"
                  :style="{
                    color: isLike ? '#2078f4' : 'inherit'
                  }"
                >
                  <span class="mr-6">
                    <i :class="buttom_like.icon"></i>
                  </span>
                  {{ buttom_like.label }}
                </div>
              </div>
            </span>

            <span class="commentary-tool b-two">
              <div
                @click="message_comment"
                aria-label="Dejar un comentario"
                class="commentary-button w-100"
                role="button"
                tabindex="0"
              >
                <div class="_18vj">
                  <span class="mr-6">
                    <i class="el-icon-chat-dot-round"></i>
                  </span>
                  Comentar
                </div>
              </div>
            </span>
          </div>

          <div class="commentary-list">
            <div aria-label="seperator" class="separator-top"></div>
            <ul v-if="message.Comments">
              <comment-item
                v-for="commentary in message.Comments"
                :key="commentary.Id"
                :comment="commentary"
                :crate_by_profile_img_src="commentary.Employee.imageUrl"
              />
            </ul>
            <comentary-box ref="comentary_box" :message="message" />
          </div>
        </div>
      </div>
    </el-card>
  </el-timeline-item>
</template>

<script>
import CommentItem from "./CommentItem";
import { mapActions, mapGetters, mapState } from "vuex";
import ComentaryBox from "./ComentarBox";
import { formatDate } from "@/utils";

export default {
  name: "Message",
  props: {
    message: {
      type: Object
    },
    create_at_image: {
      type: String,
      default: "/static/images/avatar-2.jpg"
    },
    create_at_name: {
      type: String,
      default: "Nombre del creador"
    }
  },
  components: {
    CommentItem,
    ComentaryBox
  },
  data() {
    return {
      isLike: false
    };
  },
  mounted() {
    this.isLike = this.getIsLike(this.message.Id);
  },
  methods: {
    formatDate,
    ...mapActions({
      add_like: "message/add_like",
      remove_like: "message/remove_like",
      deleteMessage: "message/delete"
    }),
    message_like() {
      if (this.isLike) {
        this.remove_like({ message_id: this.message.Id }).then(
          () => (this.isLike = false)
        );
        this.isLike = this.getIsLike(this.message.Id);
      } else {
        this.add_like({ message_id: this.message.Id }).then(
          () => (this.isLike = true)
        );
      }
    },
    message_comment() {
      this.$refs.comentary_box.setFocusMessageBox();
    },
    handleCommand(command) {
      this.$emit("message-action", this.message.Id, command);
      if (command === "delete") {
        this.deleteMessage({ message_id: this.message.Id }).then(() => {
          this.$message.success("El mensaje fue eliminado");
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      getIsLike: "message/isLikePerUser",
      loading: "message/isLoading"
    }),
    ...mapState({ c2: (state) => state.comment.db_comments }),
    buttom_like() {
      return this.isLike
        ? { icon: "mdi mdi-thumb-down-outline", label: "No me gusta" }
        : { icon: "mdi mdi-thumb-up-outline", label: "Me gusta" };
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
@import "@/assets/scss/_mixins";

$shadow: rgba(0, 0, 0, 0.2);
$always-dark-overlay: rgba(0, 0, 0, 0.4);
$secondary-text: #b0b3b8;
$hover-overlay: rgba(255, 255, 255, 0.1);

.message-item {
  .message-header {
    .username {
      margin-left: 10px;
      font-weight: bold;
      @include text-bordered-shadow();

      a {
        color: $text-color;
        text-decoration: none;

        &:hover {
          color: $text-color-accent;
        }
      }
    }
  }

  .message-body {
    .comentary-message {
      font-family: inherit;
      padding-bottom: 16px;
      padding-right: 16px;
      padding-left: 16px;
      padding-top: 4px;
      display: block;
    }

    .commentary-box {
      .commentary-tools {
        padding-right: 0;
        padding-left: 0;
        padding-top: 4px;
        padding-bottom: 4px;
        margin: 0;
        height: 32px;
        font-size: 0.9375rem;
        display: flex;

        div {
          font-family: inherit;
        }

        .commentary-tool {
          align-items: center;
          display: flex;
          flex: 1 0 0px;
          justify-content: center;

          .commentary-button {
            cursor: pointer;
            font-family: inherit;
            text-decoration: none;
            text-align: inherit;

            box-sizing: border-box;

            position: relative;
            margin: 0;
            padding: 0;
            min-width: 0;
            min-height: 0;

            background-color: transparent;
            z-index: 0;

            display: flex;
            flex-shrink: 0;
            flex-basis: auto;
            flex-grow: 1;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            border: 0 solid rgba(0, 0, 0, 0.4);

            touch-action: none;
            list-style: none;
            outline: none;
            -webkit-tap-highlight-color: transparent;
            -webkit-user-select: none;
            -webkit-font-smoothing: antialiased;

            ._18vj {
              align-items: center;
              color: #606770;
              display: flex;
              flex: 1 0;
              font-weight: 600;
              height: 32px;
              justify-content: center;
              line-height: 14px;
              padding: 0 2px;
              position: relative;
              text-decoration: none;
              transition: 400ms cubic-bezier(0.08, 0.52, 0.52, 1) transform;

              &:hover {
                background-color: $text-color-accent;
                border-radius: 4px;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
}

.w-100 {
  width: 100%;
}

.pos-relative {
  position: relative;
}

.b-two {
  &::before {
    content: "\20\a0\20";
  }
}

.separator-top {
  margin: 0;
  padding-top: 4px;
  border-top: 1px solid #90939936;
}

.separator-bottom {
  margin: 0;
  padding-bottom: 4px;
  border-bottom: 1px solid #90939936;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
